<template>
  <div>
    <!-- Hidden print content -->
    <div v-show="false" :id="printId">
      <div class="print-container">
        <!-- Company Header -->
        <div style="overflow: hidden; margin-bottom: 6px">
          <div style="float: left">
            <p
              style="
                font-size: 14pt;
                font-weight: bold;
                margin: 0;
                letter-spacing: 1px;
              "
            >
              JMB COMPUTERS
            </p>
            <p style="font-size: 8pt; margin: 2px 0 0 0; color: #444">
              Computer &amp; Laptop Repair Services
            </p>
          </div>
          <div style="float: right; text-align: right">
            <p style="font-size: 7.5pt; margin: 0; color: #555">
              VAT REG | TIN: 703-730-173
            </p>
            <p style="font-size: 7.5pt; margin: 0; color: #555">
              Philgeps Registered Platinum
            </p>
            <p style="font-size: 7.5pt; margin: 0; color: #555">
              Cantilan, Surigao del Sur
            </p>
          </div>
        </div>

        <hr
          style="
            border: none;
            height: 3px;
            background: linear-gradient(to right, #dc2626, #2563eb);
            margin: 0 0 6px 0;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          "
        />

        <!-- Document Title -->
        <div class="document-title">
          <h1 class="title-main">{{ title }}</h1>
          <div class="title-info">
            <p v-if="documentNumber" class="doc-number">
              {{ documentLabel }}{{ documentNumber }}
            </p>
            <p v-if="documentDate" class="doc-date">
              Date: {{ formatDate(documentDate) }}
            </p>
          </div>
        </div>

        <div class="divider-thin"></div>

        <!-- Dynamic Content Slot -->
        <div class="print-content">
          <slot></slot>
        </div>

        <!-- Footer -->
        <div class="print-footer">
          <div class="footer-section">
            <p>Prepared by: {{ preparedBy }}</p>
            <p>Date: {{ formatDate(new Date()) }}</p>
          </div>
          <div class="footer-section text-center">
            <p class="thank-you">Thank you for your business!</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dotMatrixStyles } from "@/utils/printHelper";
import moment from "moment";

export default {
  name: "BasePrint",
  props: {
    title: {
      type: String,
      required: true,
    },
    documentNumber: {
      type: [String, Number],
      default: null,
    },
    documentLabel: {
      type: String,
      default: "Document No.",
    },
    documentDate: {
      type: [String, Date],
      default: null,
    },
    printId: {
      type: String,
      default: "printArea",
    },
    preparedBy: {
      type: String,
      default: function () {
        return this.$store.state?.auth?.user?.name || "Admin";
      },
    },
    autoPrint: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("MMMM DD, YYYY");
    },
    async print() {
      await this.$htmlToPaper(this.printId, {
        styles: [
          "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css",
        ],
        customStyles: dotMatrixStyles + this.getCustomStyles(),
      });

      this.$emit("printed");
    },
    getCustomStyles() {
      return `
        <style>
          .print-container {
            max-width: 8in;
            margin: 0 auto;
            padding: 0.25in;
          }

          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .document-title {
            margin: 4px 0;
          }

          .title-main {
            font-size: 14pt;
            font-weight: bold;
            color: #000;
            margin: 0 0 3px 0;
            letter-spacing: 1px;
          }

          .title-info {
            display: flex;
            justify-content: space-between;
            margin-top: 2px;
          }

          .doc-number {
            font-size: 11pt;
            color: #666;
            margin: 0;
          }

          .doc-date {
            font-size: 11pt;
            color: #666;
            margin: 0;
          }

          .divider-gradient {
            height: 3px;
            background: linear-gradient(to right, #dc2626, #2563eb);
            margin: 6px 0;
          }

          .divider {
            border-top: 2px solid #000;
            margin: 6px 0;
          }

          .divider-thin {
            border-top: 1px solid #000;
            margin: 4px 0;
          }

          .print-content {
            margin: 8px 0;
            min-height: 3in;
          }

          .print-footer {
            margin-top: 30px;
            border-top: 1px solid #000;
            padding-top: 10px;
          }

          .footer-section {
            margin: 5px 0;
          }

          .thank-you {
            font-weight: bold;
            font-size: 12pt;
            margin-top: 10px;
          }

          .text-center {
            text-align: center;
          }

          /* Table styling */
          .data-table {
            width: 100%;
            border-collapse: collapse;
            margin: 10px 0;
          }

          .data-table th {
            background-color: #f0f0f0;
            border: 1px solid #000;
            padding: 5px 8px;
            font-weight: bold;
            text-align: left;
            font-size: 10pt;
          }

          .data-table td {
            border: 1px solid #000;
            padding: 4px 8px;
            font-size: 10pt;
          }

          .data-table .text-right {
            text-align: right;
          }

          .data-table .text-center {
            text-align: center;
          }

          /* Info section */
          .info-section {
            margin: 10px 0;
          }

          .info-row {
            margin: 3px 0;
            font-size: 11pt;
          }

          .info-label {
            font-weight: bold;
            display: inline-block;
            min-width: 120px;
          }

          /* Summary section */
          .summary-section {
            margin-top: 15px;
            float: right;
            width: 300px;
          }

          .summary-row {
            display: flex;
            justify-content: space-between;
            padding: 3px 5px;
            font-size: 11pt;
          }

          .summary-row.total {
            border-top: 2px solid #000;
            font-weight: bold;
            font-size: 12pt;
            margin-top: 5px;
          }

          .clearfix::after {
            content: "";
            display: table;
            clear: both;
          }
        </style>
      `;
    },
  },
  mounted() {
    if (this.autoPrint) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.print();
        }, 300);
      });
    }
  },
};
</script>

<style scoped>
/* Component styles - not for print */
</style>
